import { useEffect, useState } from 'react';
import { Rate, Space, Text, message } from 'ui';
import { postRating } from '../../services';

type P = {
  canRate: boolean;
  canViewRating: boolean;
  contentObjectId: string;
  onRate?: (rating: number) => Promise<unknown>;
  rating: number;
  ratingAverage: string;
};

const Rating = ({ canRate, canViewRating, contentObjectId, onRate, rating, ratingAverage }: P) => {
  const [isLoading, setIsLoading] = useState(false);
  const [ratingData, setRatingData] = useState(rating);
  const [ratingAverageData, setRatingAverageData] = useState(ratingAverage);

  const onRateChange = async (value: number) => {
    const previousRatingData = ratingData;

    setIsLoading(true);
    setRatingData(value);

    try {
      await postRating({
        body: {
          content_object_id: contentObjectId,
          rating: value,
        },
      });
      await onRate?.(value);
      message.success('Your evaluation was recorded.');
    } catch {
      setRatingData(previousRatingData);
      message.error('Failed to record your evaluation.');
    }

    setIsLoading(false);
  };

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- TODO: fix later
    setRatingData(rating);
    setRatingAverageData(ratingAverage);
  }, [rating, ratingAverage]);

  return (
    <>
      {canRate ? (
        <Space orientation="horizontal">
          <Text size="small">Was this valuable?</Text>
          <Rate allowClear={false} disabled={isLoading} onChange={onRateChange} size="small" value={ratingData} />
        </Space>
      ) : null}
      {canViewRating ? (
        <Space orientation="horizontal">
          <Rate count={1} disabled size="small" value={1} />
          <Text size="small">{ratingAverageData}</Text>
        </Space>
      ) : null}
    </>
  );
};

export default Rating;
